/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjcCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjcInput from "@grapecity/wijmo.input"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import dayjs from "dayjs"
import Decimal from "decimal.js"
import React, { useContext, useEffect, useRef, useState } from "react"
import { Button, Col, Container, Row } from "react-bootstrap"
import { useSelector } from "react-redux"
import { T部所マスタ } from "../../../../components/ComboBox/BusyoComboBox"
import { T表紙分割 } from "../../../../components/ComboBox/HyosiBunkatuComboBox"
import { T区分マスタ } from "../../../../components/ComboBox/KubunComboBox"
import { T請求内訳 } from "../../../../components/ComboBox/SeikyuUtiwakeComboBox"
import TextInput from "../../../../components/InputWrapper/TextInput"
import LocalAlertComponent from "../../../../components/LocalAlertComponent"
import ConfirmModal from "../../../../components/Modal/ConfirmModal"
import {
  ModalOuter,
  TModalTypes,
} from "../../../../components/Modal/ModalOuter"
import HinmeiSearchModal from "../../../../components/SearchModal/HinmeiSearchModal"
import NinusiSeikyuSearchModal from "../../../../components/SearchModal/NinusiSeikyuSearchModal"
import TumiOrosiSakiSearchModal from "../../../../components/SearchModal/TumiOrosiSakiSearchModal"
import ZyomuinSearchModal from "../../../../components/SearchModal/ZyomuinSearchModal"
import Spinner from "../../../../components/Spinner"
import CONSTANT from "../../../../constant"
import { 区分分類コード } from "../../../../constant/enum/codes"
import {
  e計上基準日区分,
  e請求車輌区分,
} from "../../../../constant/enum/master"
import {
  e課税区分,
  e請求支払区分,
  e配車状態区分,
  受注配車区分,
} from "../../../../constant/enum/zyutuHaisya"
import VALIDATE_CONSTANT from "../../../../constant/validateConstant"
import { RootState } from "../../../../globalStore/rootreducer"
import { TZyomuinListItem } from "../../../../service/driver/TZyomuin"
import BusyoService from "../../../../service/master/busyo/busyoService"
import { T品名マスタ } from "../../../../service/master/hinmei/THinmei"
import KubunService from "../../../../service/master/kubun/kubunService"
import { TNinusiInfoGetRes } from "../../../../service/master/ninusi/TNinusi"
import NinusiSeikyuService from "../../../../service/master/ninusiseikyu/ninusiSeikyuService"
import { TTumiorosisakiListGetRes } from "../../../../service/master/tumiorosisaki/TTumiorosisaki"
import {
  THaisyaPostTukekaeReq,
  T分割受注配車,
  T車輌乗務員,
} from "../../../../service/order/haisya/THaisya"
import { TZyutyuHaisyaListGetRes } from "../../../../service/order/zyutyuHaisya/TZyutyuHaisya"
import ZyutyuHaisyaService from "../../../../service/order/zyutyuHaisya/zyutyuHaisyaService"
import { TZyutyuHaisyaPatternListGetRes } from "../../../../service/order/zyutyuHaisyaPattern/TZyutyuHaisyaPattern"
import ZyutyuHaisyaPatternService from "../../../../service/order/zyutyuHaisyaPattern/zyutyuHaisyaPatternService"
import util from "../../../../ts/util"
import commonUtil from "../../../../ts/util/commonUtil"
import {
  cast乗務員,
  cast品名,
  cast積卸先,
  is請求確認済,
  setPattern as setPatternInner,
  set同乗者売上,
  sortBy受注配車ID,
  SYプロモーション特殊条件合致チェック,
  同乗者売上計算,
  時間columns,
  積載品入力時運送料自動計算,
} from "../../../../ts/util/haisyaUtil"
import { nameofT } from "../../../../ts/util/typeUtil"
import { T支払先DataMap用Item } from "../../../../type/gridDataMap"
import { TWijmoCellTemplateContext } from "../../../../type/wijmoComponents"
import ZyutyuHaisyaPatternModal from "../../ZyutyuHaisyaList/ZyutyuHaisyaPatternModal/ZyutyuHaisyaPatternModal"
import {
  MihaisyaSearchContext,
  CalenderSearchContext,
  SearchConditionContext,
} from "../HaisyaContext"
import {
  T配車入力Grid,
  分割受注配車子入力不可Bindings,
  卸地Bindings,
  卸地車輌変更Bindings,
  卸日Bindings,
  品名Bindings,
  未配車入力時非表示Bindings,
  積地Bindings,
  積日Bindings,
  荷主Bindings,
  請求Bindings,
  運転手計上Bindings,
} from "./haisyaModalConstants"
import { checkId } from "./function"
import {
  get乗務員ItemsSourceByApi,
  get品名ItemsSourceByApi,
  get積卸ItemsSourceByApi,
  get荷主ItemsSourceByApi,
} from "../../../../ts/util/autoCompleteUtil"
import zyutyuHaisyaService from "../../../../service/order/zyutyuHaisya/zyutyuHaisyaService"
import { TApiResponse } from "../../../../service/TApiResponse"
import { showInfoToast } from "../../../../components/CustomToast"
import ZyomuinService from "../../../../service/driver/zyomuinService"
import OrosiChangeModal from "./OrosiChangeModal"
import HaisyaService from "../../../../service/order/haisya/HaisyaService"
import { TSyaryoMasterGetRes } from "../../../../service/truck/TSyaryo"
import SyaryoService from "../../../../service/truck/syaryoService"
import constants from "../../../../constant/constant"
import dateUtil from "../../../../ts/util/dateUtil"
import { useGridEventHandler } from "../../../../ts/hooks/useGridEventHandler"
import NinusiService from "../../../../service/master/ninusi/ninusiService"

interface 未配車Modal {
  title?: string
  footer?: React.ReactNode
  tumibi: string | undefined
  zyutyuHaisyaList: number[]
  isMihaisya: true
}

interface 配車Modal {
  title?: string
  footer?: React.ReactNode
  tumibi: string | undefined
  syaryoZyomuin: T車輌乗務員
  zyutyuHaisyaList: number[]
  isMihaisya: false
}

/**
 * セルテンプレート内でのreadOnlyチェック用関数
 */
const cellReadOnlyFlag = (context: TWijmoCellTemplateContext<T配車入力Grid>) =>
  !context.row.grid?.isReadOnly &&
  !context.row.isReadOnly &&
  !(context.item.請求対象フラグ === 0)

/**
 * 配車入力用モーダル
 * @param {*} props
 * @return {*} reactNode
 */
const HaisyaRegisterModal: React.FC<
  | (Omit<TModalTypes, "title"> & 未配車Modal)
  | (Omit<TModalTypes, "title"> & 配車Modal)
> = (props) => {
  const { LoginUserInfo: userInfo } = useSelector(
    (state: RootState) => state.user
  )

  const { yokueigyobiStr: 翌営業日 } = useSelector(
    (state: RootState) => state.date
  )
  const calenderSearch = useContext(CalenderSearchContext)
  const mihaisyaSearch = useContext(MihaisyaSearchContext)
  const 休日List = useSelector((state: RootState) => state.date.休日List)

  const { 運行部所コード: 受注部所コード } = useContext(SearchConditionContext)
  const 部所Ref = useRef<T部所マスタ>()

  //#region [state]

  const [isGridInitialized, setIsGridInitialized] = useState(false)

  const [変更後乗務員ID, set変更後乗務員ID] = useState<number>()
  const [変更後乗務員コード, set変更後乗務員コード] = useState<string>("")
  const [変更後乗務員名, set変更後乗務員名] = useState<string>("")

  const [部所List, set部所List] = useState<T部所マスタ[]>([])

  // 車輌データ格納
  const [車輌データ, set車輌データ] = useState<TSyaryoMasterGetRes>()

  //dataMap
  //表紙分割と請求内訳は動的生成
  const [表紙分割DataMap, set表紙分割DataMap] =
    useState<wjcGrid.DataMap<T表紙分割>>()
  const [表紙分割List, set表紙分割List] = useState<T表紙分割[]>([])
  const [請求内訳DataMap, set請求内訳DataMap] =
    useState<wjcGrid.DataMap<T請求内訳>>()
  const [請求内訳List, set請求内訳List] = useState<T請求内訳[]>([])

  const [運行部所DataMap, set運行部所DataMap] =
    useState<wjcGrid.DataMap<T部所マスタ>>()

  const [部所DataMap, set部所DataMap] = useState<wjcGrid.DataMap<T部所マスタ>>()

  //区分系
  const [単位区分DataMap, set単位区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [請求区分DataMap, set請求区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [課税区分DataMap, set課税区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [同乗場所区分DataMap, set同乗場所区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [配車状態区分DataMap, set配車状態区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [食事手当区分DataMap, set食事手当区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [稼働手当車種掛率区分DataMap, set稼働手当車種掛率区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()

  // 編集用選択行確保state
  const [選択行, set選択行] = useState<wjcGrid.Row>()

  const [モーダル検索用荷主コード, setモーダル検索用荷主コード] = useState<
    string | undefined
  >()
  const [モーダル検索用荷主名, setモーダル検索用荷主名] = useState<
    string | undefined
  >()

  // 荷主検索
  const [is荷主検索Modal, setIs荷主検索Modal] = useState(false)

  const [is荷主コード変更, setIs荷主コード変更] = useState(false)

  // 受注配車パターン検索
  const [is受注配車パターン検索Modal, setIs受注配車パターン検索Modal] =
    useState(false)

  // 積卸先検索
  const [is積卸先検索Modal, setIs積卸先検索Modal] = useState(false)
  const [積卸先検索対象, set積卸先検索対象] = useState<"積" | "卸">("積")

  // 車輌検索
  // const [is車輌検索Modal, setIs車輌検索Modal] = useState(false)
  // const [車輌検索用部所コード, set車輌検索用部所コード] = useState<
  //   string | undefined
  // >()

  // 品名検索
  const [is品名検索Modal, setIs品名検索Modal] = useState(false)

  // 乗務員検索
  const [is乗務員検索Modal, setIs乗務員検索Modal] = useState(false)
  const [乗務員検索対象, set乗務員検索対象] = useState<
    "同乗者" | "乗務員" | "一括乗務員"
  >("乗務員")
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  // 行削除モーダル
  const [contextItem, setContextItem] = useState<T配車入力Grid>()
  const [isDeleteRowConfirmModalShow, setIsDeleteRowConfirmModalShow] =
    useState(false)

  // 付替モーダル
  const [isTukekaeModal, setIsTukekaeModal] = useState(false)

  // Grid
  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [isGridRefresh, setIsGridRefresh] = useState(false)
  const [isListGot, setIsListGot] = useState(false)

  // filter用
  const editedRowData = useRef<T配車入力Grid>()

  // Spinner用
  const [isSpinnerShow, setIsSpinnerShow] = useState(false)

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()

  // エラーチェック用
  const 積日未存在List = useRef<Symbol[]>([])
  const 荷主コード未存在List = useRef<Symbol[]>([])
  const 表紙名未存在List = useRef<Symbol[]>([])
  const 請求内訳未存在List = useRef<Symbol[]>([])
  const 稼働手当未入力List = useRef<Symbol[]>([])

  const [isInvalid車番, setIsInvalid車番] = useState<boolean>(false)
  //#endregion

  //#region [grid method]

  const newItemCreator = (): Partial<T配車入力Grid> => {
    // console.log(flexGrid)
    // MEMO: gridは取れる
    // 未配車入力のときはログイン部所
    let 受注部所 = props.isMihaisya
      ? {
          受注部所ID: userInfo.部所ID,
          受注部所コード: userInfo.部所コード,
          受注部所名: userInfo.部所略称,
        }
      : {
          受注部所ID: 部所Ref.current && 部所Ref.current?.部所ID,
          受注部所コード: 受注部所コード,
          受注部所名: 部所Ref.current && 部所Ref.current?.部所略称,
        }

    const new受注配車: Partial<T配車入力Grid> = {
      row_id: Symbol(),
      受注配車ID: undefined,
      受注配車区分コード: 受注配車区分.通常貨物,
      荷主コード: "",
      ...受注部所,
      複写フラグ: 1,
      積地数: 1,
      卸地数: 1,
      繰返運行数: 1,
      積日: props.isMihaisya ? 翌営業日 : props.tumibi,
      卸日: props.isMihaisya ? 翌営業日 : props.tumibi,
      運行部所ID: 部所Ref.current && 部所Ref.current?.部所ID,
      運行部所コード: 部所Ref.current && 部所Ref.current?.部所コード,
      運行部所名: 部所Ref.current && 部所Ref.current?.部所略称,
      請求付帯料課税区分コード: e課税区分.課税,
      請求運送料課税区分コード: e課税区分.課税,
    }
    if (!props.isMihaisya) {
      new受注配車.車輌ID = props.syaryoZyomuin.車輌ID
      new受注配車.車番 = props.syaryoZyomuin.車番
      new受注配車.車種区分コード = props.syaryoZyomuin.車種区分コード
      new受注配車.トレーラ車輌ID = props.syaryoZyomuin.トレーラ車輌ID
      new受注配車.トレーラ車番 = props.syaryoZyomuin.トレーラ車番
      new受注配車.トレーラ車種区分コード =
        props.syaryoZyomuin.トレーラ車種区分コード
      new受注配車.トレーラ車種区分名称1 =
        props.syaryoZyomuin.トレーラ車種区分名称1
      //乗務員は車輌紐づきの物をそのまま表示
      new受注配車.乗務員ID = props.syaryoZyomuin.乗務員ID
      new受注配車.乗務員コード = props.syaryoZyomuin.乗務員コード
      new受注配車.乗務員名 = props.syaryoZyomuin.乗務員名
      // 未配車以外の場合車輌より稼働掛率をいれる
      if (車輌データ) {
        new受注配車.稼働手当車種掛率区分コード =
          車輌データ.稼働手当車種掛率区分コード
        new受注配車.稼働手当車種掛率区分ソート番号 =
          車輌データ.稼働手当車種掛率区分ソート番号?.toString()
        new受注配車.稼働手当車種掛率区分名称1 =
          車輌データ.稼働手当車種掛率区分名称1
      }
    }
    return new受注配車
  }

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TZyutyuHaisyaListGetRes | T配車入力Grid>,
    付替List: T分割受注配車[]
  ) => {
    //配送順 nullは1として扱う
    const newData: T配車入力Grid[] = data.map((d) => {
      // 付替Listよりデータを取得し埋める
      const 付替 = 付替List.find((t) => t.受注配車ID === d.受注配車ID)
      const returnData: T配車入力Grid = {
        ...d,
        row_id: Symbol(),
        配送順: d.配送順 ?? 1,
      }
      if (付替) {
        returnData.卸地分割部所ID = 付替.分割運行部所ID
        returnData.卸地分割部所名 = 付替.分割運行部所名
        returnData.卸地分割受注配車ID = 付替.受注配車ID
        returnData.請求対象フラグ = 付替.請求対象フラグ
      }
      return returnData
    })

    return new wjcCore.CollectionView<T配車入力Grid>(newData, {
      collectionChanged: (a: wjcCore.CollectionView) => {
        if (flexGrid == null) return
        flexGrid.allowAddNew =
          a.sourceCollection.length < CONSTANT.一日最大配送数
        flexGrid.refresh()
      },
      newItemCreator,
      // sortDescriptions: [
      //   new wjcCore.SortDescription("積日", true),
      //   new wjcCore.SortDescription("配送順", true),
      // ],
      calculatedFields: {
        車輌最大積載量: (data: T配車入力Grid) =>
          data.トレーラ車種最大積載量 ?? data.最大積載量,
        受注No: (data: T配車入力Grid) => {
          if (data.受注伝票番号 != null && data.受注伝票番号 !== "") {
            const text = `${data.受注伝票番号}${
              data.受注枝番 != null && data.受注枝番 > 0
                ? `-${data.受注枝番}`
                : data.複写フラグ === 1
                ? "-??"
                : ""
            }`
            return text
          } else {
            return ""
          }
        },
        padding車番: (data: T配車入力Grid) =>
          data.車番 != null && data.車番 !== ""
            ? data.車番?.padStart(4, "0")
            : "9999",
        支払合計: (data: T配車入力Grid) => {
          const 支払運送料 = new Decimal(data.支払運送料 ?? 0)
          const 支払付帯料 = new Decimal(data.支払付帯料 ?? 0)
          const 支払高速料 = new Decimal(data.支払高速料 ?? 0)
          return 支払運送料.plus(支払付帯料).plus(支払高速料).toNumber()
        },
        請求合計: (data: T配車入力Grid) => {
          const 請求運送料 = new Decimal(data.請求運送料 ?? 0)
          const 請求付帯料 = new Decimal(data.請求付帯料 ?? 0)
          const 請求高速料 = new Decimal(data.請求高速料 ?? 0)
          return 請求運送料.plus(請求付帯料).plus(請求高速料).toNumber()
        },
      },
    })
  }

  const gridInitialized = (grid: wjcGrid.FlexGrid) => {
    grid.columnHeaders.rows.defaultSize = 35

    // header行に一行追加
    let extraRow = new wjcGrid.Row()
    extraRow.allowMerging = true
    let columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    columnHeaders.columns.forEach((c, index) => {
      if (c.binding != null) {
        let setHeaderText = ""
        if (荷主Bindings.includes(c.binding)) {
          setHeaderText = "荷主"
        } else if (積日Bindings.includes(c.binding)) {
          setHeaderText = "積日"
        } else if (卸日Bindings.includes(c.binding)) {
          setHeaderText = "卸日"
        } else if (積地Bindings.includes(c.binding)) {
          setHeaderText = "積地"
        } else if (卸地車輌変更Bindings.includes(c.binding)) {
          setHeaderText = "卸地車輌変更"
        } else if (卸地Bindings.includes(c.binding)) {
          setHeaderText = "卸地"
        } else if (品名Bindings.includes(c.binding)) {
          setHeaderText = "品名"
        } else if (請求Bindings.includes(c.binding)) {
          setHeaderText = "請求"
        } else if (運転手計上Bindings.includes(c.binding)) {
          setHeaderText = "乗務員売上"
        } else {
          setHeaderText = c.header ?? ""
        }
        c.allowMerging = true
        c.align = "left"
        columnHeaders.setCellData(0, index, setHeaderText)
      }
    })
    // grid.cellEditEnded.addHandler(cellEditEnded)
    // grid.pastedCell.addHandler(pastedCell)
    grid.beginningEdit.addHandler(beginningEdit)
    grid.formatItem.addHandler(formatItem)
    setFlexGrid(grid)
  }

  // パターン検索用
  const getPatternItemsSource = (
    query: string,
    max: number,
    callback: (items: TZyutyuHaisyaPatternListGetRes[]) => void
  ) => {
    if (query == null || wjcCore.isNullOrWhiteSpace(query)) {
      callback([])
      return
    } else {
      const service = new ZyutyuHaisyaPatternService()
      return service
        .getList({ 受注配車パターンコード: query, 受注部所コード })
        .then((res) => {
          const selectItem = res.data
            ? res.data.map((d) => {
                let displayName = `${d.受注配車パターンコード ?? ""}`
                let detailText = ``
                detailText = commonUtil.addTextWithStartDelimiter(detailText, [
                  d.荷主略称1,
                  d.積地社名,
                  d.卸地社名,
                  d.品名,
                ])
                if (detailText !== "") {
                  displayName += `: ${detailText}`
                }
                return { ...d, displayName }
              })
            : []

          callback(selectItem)
        })
    }
  }

  /**
   * セル編集完了時イベント
   */
  const cellEditEnded = async (
    s: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    let col = s.columns[e.col]

    if (e.cancel === true) {
      return
    }

    let newValue = s.getCellData(e.row, e.col, false)
    let dataItem: T配車入力Grid = e.getRow().dataItem

    switch (col.binding as keyof TZyutyuHaisyaListGetRes) {
      case "荷主コード":
        if (col.editor == null) return
        const 荷主Editor = col.editor as wjcInput.AutoComplete
        const 荷主selectedItem = 荷主Editor.selectedItem as TNinusiInfoGetRes
        if (荷主selectedItem == null) {
          if (wjcCore.isNullOrWhiteSpace(dataItem.荷主コード ?? "")) {
            dataItem.荷主コード = ""
            dataItem.荷主ID = undefined
            dataItem.荷主名 = undefined
          } else {
            const 荷主Res = await new NinusiService().getList({
              完全一致フラグ: true,
              荷主コード: dataItem.荷主コード,
            })

            if (
              荷主Res.data &&
              荷主Res.data.length > 0 &&
              荷主Res.data[0] != null
            ) {
              dataItem.荷主コード = 荷主Res.data[0].荷主コード
              dataItem.荷主ID = 荷主Res.data[0].荷主ID
              dataItem.荷主名 = 荷主Res.data[0].荷主略称1
            } else {
              dataItem.荷主コード = ""
              dataItem.荷主ID = undefined
              dataItem.荷主名 = undefined
            }
          }
        } else {
          dataItem.荷主コード = 荷主selectedItem.荷主コード
          dataItem.荷主ID = 荷主selectedItem.荷主ID
          dataItem.荷主名 = 荷主selectedItem.荷主略称1
        }
        s.refresh()
        setIs荷主コード変更(true)
        break
      case nameofT<TZyutyuHaisyaListGetRes>("荷主請求ID"):
        if (newValue === e.data) return
        const 荷主請求: T表紙分割 = col.dataMap?.getDataItem(newValue)
        if (荷主請求) {
          dataItem.表紙分割コード = 荷主請求.表紙分割コード
          setIsListGot(true)
        } else {
          dataItem.表紙分割コード = ""
        }
        // 変更時は荷主請求内訳を消去する
        dataItem.荷主請求内訳ID = undefined
        dataItem.計上基準日区分名称1 = ""
        dataItem.計上基準日区分コード = ""
        dataItem.請求車輌区分コード = ""
        dataItem.請求車輌区分名称1 = ""
        dataItem.請求計上日 = ""
        dataItem.請求車番 = ""

        // 税込高速料を埋める
        if (newValue != null) {
          const 表紙分割 = 表紙分割List?.find(
            (表紙分割) => 表紙分割.荷主請求ID === newValue
          )
          if (表紙分割) {
            dataItem.請求高速料税込区分コード = 表紙分割.高速料税込区分コード
            dataItem.請求高速料税込区分名称1 = 表紙分割.高速料税込区分名称1
            dataItem.支払高速料税込区分コード = 表紙分割.高速料税込区分コード
            dataItem.品代端数計算区分コード = 表紙分割.品代端数計算区分コード
            dataItem.品代端数計算区分ソート番号 =
              表紙分割.品代端数計算区分ソート番号
            dataItem.品代端数計算区分名称1 = 表紙分割.品代端数計算区分名称1
          }
        }
        s.refresh()

        break
      // case "荷主請求ID":
      //   dataItem.表紙名 = dataItem.荷主請求ID?.toString()
      //   break
      case "荷主請求内訳ID":
        if (dataItem.荷主請求内訳ID) {
          const 請求内訳 = 請求内訳List?.find(
            (i) => i.荷主請求内訳ID === dataItem.荷主請求内訳ID
          )
          if (請求内訳) {
            // 計上基準日区分、請求車輌区分を自動で入れる
            dataItem.計上基準日区分名称1 = 請求内訳.計上基準日区分名称1
            dataItem.計上基準日区分コード = 請求内訳.計上基準日区分コード
            dataItem.請求車輌区分コード = 請求内訳.請求車輌区分コード
            dataItem.請求車輌区分名称1 = 請求内訳.請求車輌区分名称1
            // 請求車番を自動設定
            set請求車番(dataItem)
            // 計上基準日区分に応じた内容を入れる
            switch (請求内訳.計上基準日区分コード) {
              case e計上基準日区分.積日:
                dataItem.請求計上日 = dataItem.積日
                break
              case e計上基準日区分.卸日:
                dataItem.請求計上日 = dataItem.卸日
                break
            }
          } else {
            dataItem.計上基準日区分名称1 = ""
            dataItem.計上基準日区分コード = ""
            dataItem.請求車輌区分コード = ""
            dataItem.請求車輌区分名称1 = ""
            dataItem.請求計上日 = ""
            dataItem.請求車番 = ""
          }
        } else {
          dataItem.計上基準日区分名称1 = ""
          dataItem.計上基準日区分コード = ""
          dataItem.請求車輌区分コード = ""
          dataItem.請求車輌区分名称1 = ""
          dataItem.請求計上日 = ""
          dataItem.請求車番 = ""
        }
        s.refresh()
        break
      case "受注配車パターンコード":
        // 空文字やnull undefinedのときはスルー
        // autoCompleteのバグ？なのかselectedValueではなく、displayMemberPathの値が入ってきてしまうため、
        // 現在のeditorを直接参照し、値を詰め込むようにする。
        if (col.editor == null) return
        const cellEditor = col.editor as wjcInput.AutoComplete
        if (cellEditor.selectedItem != null) {
          setPattern(cellEditor.selectedItem, dataItem, false)
          set請求車番(dataItem)
          setIsListGot(true)
          setIs荷主コード変更(true)
          setIsGridRefresh(true)
        } else {
          // 文字列と完全一致するものがあったら登録
          if (cellEditor.text != null && cellEditor.text !== "") {
            const autoCompleteItems = cellEditor.collectionView
              .sourceCollection as TZyutyuHaisyaPatternListGetRes[]
            const targetPattern = autoCompleteItems.find(
              (i) =>
                i.受注配車パターンコード === cellEditor.text &&
                i.受注部所コード === 受注部所コード
            )
            if (targetPattern) {
              setPattern(targetPattern, dataItem, false)
              setIsGridRefresh(true)
            } else {
              // なかった場合、積卸と品名情報の複数登録は不可となるため、積地数・卸地数・品数を1に戻す
              dataItem.積地数 = 1
              dataItem.卸地数 = 1
              dataItem.品数 = 1
            }
          } else {
            // なかった場合、積卸と品名情報の複数登録は不可となるため、積地数・卸地数・品数を1に戻す
            dataItem.積地数 = 1
            dataItem.卸地数 = 1
            dataItem.品数 = 1
          }
        }

        s.refresh()
        break
      case "傭車会社コード":
        if (col.editor == null) return
        const 傭車会社Editor = col.editor as wjcInput.AutoComplete
        const 傭車会社selectedItem =
          傭車会社Editor.selectedItem as T支払先DataMap用Item
        if (傭車会社selectedItem != null) {
          dataItem.傭車会社名 = 傭車会社selectedItem.支払先略称
        } else {
          dataItem.傭車会社名 = ""
        }
        break
      case "積地積卸先コード":
        if (col.editor == null) return
        const 積地積卸先Editor = col.editor as wjcInput.AutoComplete
        cast積卸先(
          dataItem,
          積地積卸先Editor.selectedItem as TTumiorosisakiListGetRes,
          "積"
        )
        s.refresh()
        break
      case "積地社名":
      case "積地都道府県":
      case "積地市区町村":
        if (newValue === e.data) return
        dataItem.is積地手編集 = true
        break
      case "卸地積卸先コード":
        const 卸地積卸先Editor = col.editor as wjcInput.AutoComplete
        cast積卸先(
          dataItem,
          卸地積卸先Editor.selectedItem as TTumiorosisakiListGetRes,
          "卸"
        )
        s.refresh()
        break
      case "卸地社名":
      case "卸地都道府県":
      case "卸地市区町村":
        if (newValue === e.data) return
        dataItem.is卸地手編集 = true
        break
      case "乗務員名":
      case "同乗者名":
        if (col.editor == null) return
        const 乗務員Editor = col.editor as wjcInput.AutoComplete
        const 乗務員selectedItem = 乗務員Editor.selectedItem as TZyomuinListItem
        if (乗務員selectedItem != null) {
          if (col.binding === "乗務員名") {
            cast乗務員(dataItem, 乗務員selectedItem, "乗務員")
          } else {
            cast乗務員(dataItem, 乗務員selectedItem, "同乗者")
          }
        } else {
          //一件のときはそのデータを入れる
          let 乗務員selectedItem: TZyomuinListItem | null
          if (乗務員Editor.collectionView.sourceCollection.length === 1) {
            乗務員selectedItem = 乗務員Editor.collectionView
              .sourceCollection[0] as TZyomuinListItem
          } else {
            乗務員selectedItem = null
          }
          if (col.binding === "乗務員名") {
            cast乗務員(dataItem, 乗務員selectedItem, "乗務員")
          } else {
            cast乗務員(dataItem, 乗務員selectedItem, "同乗者")
          }
        }

        // 同乗者の場合、同乗者売り上げも操作する
        if (col.binding === "同乗者名") {
          if (dataItem.同乗者乗務員ID == null) {
            dataItem.同乗者売上額 = 0
          } else if (
            dataItem.同乗者売上額 === 0 ||
            dataItem.同乗者売上額 == null
          ) {
            dataItem.同乗者売上額 = set同乗者売上(dataItem)
          }
        }
        s.refresh()
        break
      case "品コード":
        const 品コードEditor = col.editor as wjcInput.AutoComplete
        cast品名(dataItem, 品コードEditor.selectedItem as T品名マスタ)
        s.refresh()
        break
      case "品名":
      case "単位区分コード":
        if (newValue === e.data) return
        dataItem.is品名手編集 = true
        break
      case "積載品数量":
      case "単価":
        積載品入力時運送料自動計算(dataItem)
        break
      case "請求車番":
        // 手入力を行った時点でIDを消す
        // MEMO: ほかで使っていない項目なので特に気にせず消す
        dataItem.請求車輌ID = undefined
        s.refresh()
        break
      case "請求運送料":
        if (dataItem.is乗務員売上手編集) {
          break
        }

        dataItem.乗務員売上額 = dataItem.請求運送料
        dataItem.同乗者売上額 = set同乗者売上(dataItem)
        s.refresh()
        break
      case "請求付帯料":
        if (dataItem.is乗務員売上手編集) {
          break
        }
        dataItem.乗務員付帯料 = dataItem.請求付帯料
        s.refresh()
        break
      case "請求高速料":
        if (dataItem.is乗務員売上手編集) {
          break
        }
        dataItem.付帯高速料 = dataItem.請求高速料
        s.refresh()
        break
      default:
        break
    }
    // SYプロモーション特殊条件用
    if (SYプロモーション特殊条件合致チェック(dataItem)) {
      if (dataItem.請求付帯料 == null || dataItem.請求付帯料 === 0) {
        dataItem.請求付帯料 = constants.SYプロモーション特殊条件.付帯料
        dataItem.乗務員付帯料 = 0
        dataItem.請求備考 = constants.SYプロモーション特殊条件.請求備考
        s.refresh()
      }
    }

    editedRowData.current = undefined
  }

  /**
   * セルペースト完了時イベント
   */
  const pastedCell = async (
    s: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    let col = s.columns[e.col]

    if (e.cancel === true) {
      return
    }
    let dataItem: T配車入力Grid = e.getRow()?.dataItem
    if (!dataItem) return

    switch (col.binding as keyof TZyutyuHaisyaListGetRes) {
      case "積載品数量":
      case "単価":
        積載品入力時運送料自動計算(dataItem)
        break
      case "請求車番":
        // 手入力を行った時点でIDを消す
        // MEMO: ほかで使っていない項目なので特に気にせず消す
        dataItem.請求車輌ID = undefined
        s.refresh()
        break
      case "請求運送料":
        if (dataItem.is乗務員売上手編集) {
          break
        }

        dataItem.乗務員売上額 = dataItem.請求運送料
        dataItem.同乗者売上額 = set同乗者売上(dataItem)
        s.refresh()
        break
      case "請求付帯料":
        if (dataItem.is乗務員売上手編集) {
          break
        }
        dataItem.乗務員付帯料 = dataItem.請求付帯料
        s.refresh()
        break
      case "請求高速料":
        if (dataItem.is乗務員売上手編集) {
          break
        }
        dataItem.付帯高速料 = dataItem.請求高速料
        s.refresh()
        break
      default:
        break
    }
    // SYプロモーション特殊条件用
    if (SYプロモーション特殊条件合致チェック(dataItem)) {
      if (dataItem.請求付帯料 == null || dataItem.請求付帯料 === 0) {
        dataItem.請求付帯料 = constants.SYプロモーション特殊条件.付帯料
        dataItem.乗務員付帯料 = 0
        dataItem.請求備考 = constants.SYプロモーション特殊条件.請求備考
        s.refresh()
      }
    }

    editedRowData.current = undefined
  }

  /**
   * セル編集開始時イベント
   * @param s
   * @param e
   * @returns
   */
  const beginningEdit = (
    s: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    let col = s.columns[e.col]
    const binding = col.binding as keyof T配車入力Grid
    let dataItem: T配車入力Grid = e.getRow().dataItem
    editedRowData.current = dataItem
    // 請求額確認済みの場合は編集不可
    if (is請求確認済(dataItem)) {
      e.cancel = true
      return
    }

    // 分割受注配車の子レコードは一部修正不可
    // 親レコード更新時に同時に更新を行う
    if (dataItem.請求対象フラグ === 0) {
      if (分割受注配車子入力不可Bindings.includes(binding)) {
        e.cancel = true
        return
      }
    }

    switch (binding) {
      case "受注配車パターンコード":
        if (dataItem.受注配車ID != null && dataItem.受注配車ID !== 0) {
          e.cancel = true
          return
        }
        break
      case "積日":
      case "積時間":
      case "積地積卸先コード":
      case "積地社名":
      case "積地都道府県":
      case "積地市区町村":
        if (dataItem.積地数 != null && dataItem.積地数 > 1) {
          e.cancel = true
          return
        }
        break
      case "卸日":
      case "卸時間":
      case "卸地積卸先コード":
      case "卸地社名":
      case "卸地都道府県":
      case "卸地市区町村":
        // 卸地情報が複数の場合readOnlyに設定
        if (dataItem.卸地数 != null && dataItem.卸地数 > 1) {
          e.cancel = true
          return
        }
        break
      case "品名":
        // 卸地情報が複数の場合readOnlyに設定
        // 品名が99999でない場合はreadOnlyに設定
        if (
          (dataItem.品数 != null && dataItem.品数 > 1) ||
          dataItem.品コード !== CONSTANT.自由入力品コード
        ) {
          e.cancel = true
          return
        }
        break
      case "品コード":
      case "単位区分コード":
      case "積載品数量":
        // 卸地情報が複数の場合readOnlyに設定
        if (dataItem.品数 != null && dataItem.品数 > 1) {
          e.cancel = true
          return
        }
        break
      //請求区分が「品数毎」ではない場合、単価は登録されないため入力不可とする。
      // また、複数の場合も入力不可
      case "単価":
        if (
          dataItem.請求区分コード == null ||
          dataItem.請求区分コード !== e請求支払区分.品数毎
        ) {
          e.cancel = true
          return
        }
        if (dataItem.品数 != null && dataItem.品数 > 1) {
          e.cancel = true
          return
        }
        break
      case "乗務員売上額":
      case "乗務員付帯料":
      case "付帯高速料":
        if (!dataItem.is乗務員売上手編集) {
          e.cancel = true
          return
        }
        break
      default:
        break
    }
    // 時間対象のカラムのとき、日曜と休日に色付け
    時間columns.forEach((binding) => {
      if (col.binding === binding && col.editor) {
        const editor = col.editor as wjcInput.InputDate
        editor.calendar.formatItem.removeAllHandlers()
        // 積日と卸日のときはさらに休日も色付け
        editor.calendar.formatItem.addHandler(
          dateUtil.inputDateOffDayFormatHandler(
            ["積日", "卸日"].includes(binding) ? 休日List : []
          )
        )
      }
    })
  }

  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      const cellBinding = e.getColumn().binding as keyof T配車入力Grid
      const targetRow = e.getRow()
      const dataItem: T配車入力Grid = targetRow.dataItem

      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        //削除済フラグの行はreadonly
        if (dataItem.削除フラグ) {
          wjcCore.toggleClass(e.cell, "read-only-cell", true)
          return
        }
        //請求額確認済みの行はreadonly
        if (is請求確認済(dataItem)) {
          wjcCore.toggleClass(e.cell, "read-only-cell", true)
          return
        }

        switch (cellBinding as keyof T配車入力Grid) {
          case "受注配車パターンコード":
            wjcCore.toggleClass(
              e.cell,
              "read-only-cell",
              dataItem.受注配車ID != null && dataItem.受注配車ID !== 0
            )
            break
          case "荷主コード":
            if (
              荷主コード未存在List.current != null &&
              荷主コード未存在List.current.length > 0
            ) {
              const is未存在 = 荷主コード未存在List.current.find(
                (d) => d === dataItem.row_id
              )
                ? true
                : false
              wjcCore.toggleClass(e.cell, "data-warning", is未存在)
            }
            break
          case "荷主請求ID":
            if (
              表紙名未存在List.current != null &&
              表紙名未存在List.current.length > 0
            ) {
              const is未存在 = 表紙名未存在List.current.find(
                (d) => d === dataItem.row_id
              )
                ? true
                : false
              wjcCore.toggleClass(e.cell, "data-warning", is未存在)
            }
            break
          case "積日":
            if (
              積日未存在List.current != null &&
              積日未存在List.current.length > 0
            ) {
              const is未存在 = 積日未存在List.current.find(
                (d) => d === dataItem.row_id
              )
                ? true
                : false
              wjcCore.toggleClass(e.cell, "data-warning", is未存在)
            }
            // 積地情報が複数の場合readOnlyに設定
            wjcCore.toggleClass(
              e.cell,
              "read-only-cell",
              !props.isMihaisya ||
                (dataItem.積地数 != null && dataItem.積地数 > 1)
            )

            // 休日の場合は色を変更
            wjcCore.toggleClass(
              e.cell,
              "date-sunday",
              dateUtil.HolidayCheck(dataItem.積日, 休日List) === 1
            )
            wjcCore.toggleClass(
              e.cell,
              "date-holiday",
              dateUtil.HolidayCheck(dataItem.積日, 休日List) === 2
            )

            break
          case "積時間":
          case "積地積卸先コード":
          case "積地社名":
          case "積地都道府県":
          case "積地市区町村":
            // 積地情報が複数の場合readOnlyに設定
            wjcCore.toggleClass(
              e.cell,
              "read-only-cell",
              dataItem.積地数 != null && dataItem.積地数 > 1
            )
            // 手入力での編集が行われていた場合青文字に設定
            wjcCore.toggleClass(
              e.cell,
              "text-primary",
              dataItem.is積地手編集 != null ? dataItem.is積地手編集 : false
            )
            break
          case "卸日":
            // 休日の場合は色を変更
            wjcCore.toggleClass(
              e.cell,
              "date-sunday",
              dateUtil.HolidayCheck(dataItem.卸日, 休日List) === 1
            )
            wjcCore.toggleClass(
              e.cell,
              "date-holiday",
              dateUtil.HolidayCheck(dataItem.卸日, 休日List) === 2
            )

            break
          case "卸時間":
          case "卸地積卸先コード":
          case "卸地社名":
          case "卸地都道府県":
          case "卸地市区町村":
            // 卸地情報が複数の場合readOnlyに設定
            wjcCore.toggleClass(
              e.cell,
              "read-only-cell",
              dataItem.卸地数 != null && dataItem.卸地数 > 1
            )
            // 手入力での編集が行われていた場合青文字に設定
            wjcCore.toggleClass(
              e.cell,
              "text-primary",
              dataItem.is卸地手編集 != null ? dataItem.is卸地手編集 : false
            )
            break
          case "品名":
            // 品数が複数の場合readOnlyに設定
            // 品コードが99999でない場合はreadOnlyに設定
            wjcCore.toggleClass(
              e.cell,
              "read-only-cell",
              (dataItem.品数 != null && dataItem.品数 > 1) ||
                dataItem.品コード !== CONSTANT.自由入力品コード
            )
            // 品コードが99999の場合青文字に設定
            wjcCore.toggleClass(
              e.cell,
              "text-primary",
              dataItem.品コード === CONSTANT.自由入力品コード
            )

            break
          case "品コード":
          case "単位区分コード":
          case "積載品数量":
            // 品数が複数の場合readOnlyに設定
            wjcCore.toggleClass(
              e.cell,
              "read-only-cell",
              dataItem.品数 != null && dataItem.品数 > 1
            )
            // 品コードが99999の場合青文字に設定
            wjcCore.toggleClass(
              e.cell,
              "text-primary",
              dataItem.品コード === CONSTANT.自由入力品コード
            )
            break
          case "運行部所コード":
            wjcCore.toggleClass(e.cell, "read-only-cell", !props.isMihaisya)
            break
          //請求区分が「品数毎」ではない場合、単価は登録されないため入力不可とする。
          case "単価":
            wjcCore.toggleClass(
              e.cell,
              "read-only-cell",
              (dataItem.品数 != null && dataItem.品数 > 1) ||
                dataItem.請求区分コード == null ||
                dataItem.請求区分コード !== e請求支払区分.品数毎
            )
            break
          case "乗務員売上額":
          case "乗務員付帯料":
          case "付帯高速料":
            wjcCore.toggleClass(
              e.cell,
              "read-only-cell",
              !dataItem.is乗務員売上手編集
            )
            break
          case "稼働手当車種掛率区分コード":
            if (
              稼働手当未入力List.current != null &&
              稼働手当未入力List.current.length > 0
            ) {
              const is未存在 = 稼働手当未入力List.current.find(
                (d) => d === dataItem.row_id
              )
                ? true
                : false
              wjcCore.toggleClass(e.cell, "data-warning", is未存在)
            }
            break
          default:
            break
        }

        // 既にreadOnlyになっていた場合処理しない
        if (!wjcCore.hasClass(e.cell, "read-only-cell")) {
          // 分割された受注配車で、子側の受注配車に関しては一部編集不可とする
          wjcCore.toggleClass(
            e.cell,
            "read-only-cell",
            分割受注配車子入力不可Bindings.includes(cellBinding) &&
              dataItem.請求対象フラグ === 0
          )
        }
      }
    }
  }

  //#endregion

  //#region [method]

  const setPattern = (
    パターン: TZyutyuHaisyaPatternListGetRes,
    castedData: TZyutyuHaisyaListGetRes,
    set車輌情報?: boolean
  ) => {
    setPatternInner(パターン, castedData, set車輌情報)
    // 配車済の場合、車輌データより車輌情報の上書きと稼働掛率を設定する
    if (!props.isMihaisya && 車輌データ) {
      castedData.車輌ID = 車輌データ.車輌ID
      castedData.車番 = 車輌データ.車番
      castedData.車種区分コード = 車輌データ.車種区分コード
      castedData.稼働手当車種掛率区分コード =
        車輌データ.稼働手当車種掛率区分コード
      castedData.稼働手当車種掛率区分ソート番号 =
        車輌データ.稼働手当車種掛率区分ソート番号?.toString()
      castedData.稼働手当車種掛率区分名称1 =
        車輌データ.稼働手当車種掛率区分名称1
    }
  }

  const set請求車番 = (dataItem: T配車入力Grid) => {
    // 未配車の場合は処理しない
    if (!props.isMihaisya) {
      if (dataItem.請求車輌区分コード === e請求車輌区分.ヘッド) {
        dataItem.請求車輌ID = props.syaryoZyomuin?.車輌ID
        dataItem.請求車番 = props.syaryoZyomuin?.車番
      }
      if (dataItem.請求車輌区分コード === e請求車輌区分.トレーラー) {
        dataItem.請求車輌ID = props.syaryoZyomuin?.トレーラ車輌ID
        dataItem.請求車番 = props.syaryoZyomuin?.トレーラ車番
      }
    }
  }

  /**
   * 検索
   */
  const search = async () => {
    if (props.zyutyuHaisyaList.length <= 0) return []
    try {
      const service = new ZyutyuHaisyaService()
      const 受注配車res = await service.getListById({
        受注配車IdList: props.zyutyuHaisyaList,
      })

      return 受注配車res.data
    } catch (error) {
      throw error
    }
  }

  /**
   * 付替受注配車取得
   */
  const getTukekae = async () => {
    if (props.zyutyuHaisyaList.length <= 0) return []
    try {
      const 付替配車ListRes =
        await new HaisyaService().getBunkatuZyutyuHaisyaList({
          IdList: props.zyutyuHaisyaList,
        })

      return 付替配車ListRes.data
    } catch (error) {
      throw error
    }
  }

  const set配送順 = (index: number, nextIndex: number) => {
    if (flexGrid == null) return
    const cv = flexGrid.collectionView as wjcCore.CollectionView<T配車入力Grid>
    cv.beginUpdate()

    const source = cv.sourceCollection as T配車入力Grid[]
    const rowID配送順List = source.map((s) => s.row_id)

    rowID配送順List.splice(
      nextIndex,
      2,
      rowID配送順List[index],
      rowID配送順List[nextIndex]
    )
    // 配送順リストに合わせて各データに配送順を再展開
    source.forEach((s) => {
      const index = rowID配送順List.findIndex((r) => r === s.row_id)
      if (index !== -1) {
        s.配送順 = index + 1
      } else {
        s.配送順 = 0
      }
    })
    source.sort((a, b) => a.配送順! - b.配送順!)
    cv.endUpdate()
    cv.refresh()
    // flexGrid.itemsSource = createCollectionView(source)
    flexGrid.refresh()
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    if (!flexGrid) return
    setAlertSource(undefined)
    let messages: string[] = []
    let isError = false
    const gridItems: T配車入力Grid[] = flexGrid.collectionView.sourceCollection
    const putData: T配車入力Grid[] = []
    gridItems.forEach((d) => {
      // 品数がnullの場合は1を入れる
      if (!d.品数) {
        d.品数 = 1
      }
      // 複写フラグがある行は選択していなくても登録する
      if (d.受注配車ID == null) {
        d.受注配車区分コード = 受注配車区分.通常貨物
      }
      putData.push(d)
    })

    // 必須チェック
    const 必須Valid = 必須validate(putData)
    isError = 必須Valid.hasError === true ? true : isError
    messages.push(...必須Valid.messages)

    // 乗務員変更チェック
    if (
      変更後乗務員コード != null &&
      変更後乗務員コード !== "" &&
      変更後乗務員ID == null
    ) {
      isError = true
      messages.push("変更後乗務員コードが有効な乗務員コードではありません。")
    }

    if (isError) {
      setAlertSource({ warns: messages })
      flexGrid?.refresh()
      return
    }

    setIsConfirmModalShow(true)
  }

  /**
   * 必須チェック
   * @param putData: T受注配車入力GridItem[]
   */
  const 必須validate = (putData: T配車入力Grid[]) => {
    let 必須エラー = false
    let 表紙名エラー = false
    let 積卸情報エラー = false
    let 荷主コードエラー = false
    let 請求内訳エラー = false
    let 稼働手当エラー = false
    const エラーメッセージList: string[] = []

    if (受注部所コード == null || 受注部所コード === "") {
      必須エラー = true
      エラーメッセージList.push("受注部所は必須入力です")
    }

    // グリッド内の必須確認
    // TODO: schemaを使ったチェックに変更予定
    putData.forEach((d) => {
      // 未配車登録の場合処理しない
      if (!props.isMihaisya) {
        if (d.積日 == null || d.積日 === "") {
          if (!積卸情報エラー) {
            積卸情報エラー = true
            エラーメッセージList.push("積日は必須入力です")
          }
          積日未存在List.current.push(d.row_id)
        }
      }
      if (d.荷主コード == null || d.荷主コード === "") {
        if (!荷主コードエラー) {
          荷主コードエラー = true
          エラーメッセージList.push("荷主コードは必須入力です")
        }
        荷主コード未存在List.current.push(d.row_id)
      }
      if (d.荷主請求ID == null) {
        if (!表紙名エラー) {
          表紙名エラー = true
          エラーメッセージList.push("表紙名は必須入力です")
        }
        表紙名未存在List.current.push(d.row_id)
      }
      if (d.荷主請求内訳ID == null) {
        if (!請求内訳エラー) {
          請求内訳エラー = true
          エラーメッセージList.push("請求内訳は必須入力です")
        }
        請求内訳未存在List.current.push(d.row_id)
      }

      // 傭車以外で車輌が存在するときに、稼働掛率の入っていない車輌が存在していた場合エラーとする
      if (
        d.車輌ID != null &&
        wjcCore.isNullOrWhiteSpace(d.稼働手当車種掛率区分コード ?? "")
      ) {
        if (!稼働手当エラー) {
          稼働手当エラー = true
          エラーメッセージList.push(
            "稼働掛率が設定されていない車輌です。稼働掛率の設定を依頼して下さい"
          )
        }
        稼働手当未入力List.current.push(d.row_id)
      }
    })

    return {
      hasError:
        必須エラー ||
        表紙名エラー ||
        積卸情報エラー ||
        荷主コードエラー ||
        請求内訳エラー ||
        稼働手当エラー,
      messages: エラーメッセージList,
    }
  }

  /**
   * グリッド登録
   * @param gridData
   */
  const gridRegister = async () => {
    if (flexGrid == null) return
    try {
      const gridItems: TZyutyuHaisyaListGetRes[] =
        flexGrid.collectionView.sourceCollection
      const putData: TZyutyuHaisyaListGetRes[] = []
      gridItems.forEach((gridItem, rowIndex) => {
        // 品数がnullの場合は1を入れる
        if (!gridItem.品数) {
          gridItem.品数 = 1
        }

        gridItem.受注配車区分コード = 受注配車区分.通常貨物

        if (!props.isMihaisya) {
          // 積日が過去の日付の配送の場合、配送順は触らない
          const isBefore積日 = dayjs(gridItem.積日).isBefore(
            dayjs(props.tumibi),
            "date"
          )
          if (isBefore積日) {
            gridItem.配送順 = gridItem.配送順 ?? 1
          } else {
            // 見た目のままに配送順を入力しておく
            // バックエンド側で同一積日の配送順は前に詰めて登録される
            gridItem.配送順 = rowIndex + 1
          }
          // 車輌を入力中のものに変更
          gridItem.車輌ID = props.syaryoZyomuin.車輌ID
          gridItem.車番 = props.syaryoZyomuin.車番
          gridItem.車種区分コード = props.syaryoZyomuin.車種区分コード
          gridItem.車種区分名称1 = props.syaryoZyomuin.車種区分名称1
          // 分割車輌の場合

          // gridItem.トレーラ車輌ID = props.syaryoZyomuin.トレーラ車輌ID
          // gridItem.トレーラ車番 = props.syaryoZyomuin.トレーラ車番

          gridItem.配車状態区分コード = e配車状態区分.配車確定
          // 請求車番が空の場合、請求内訳を確認し車番トレーラ車番より設定する。
          if (gridItem.請求車輌区分コード === e請求車輌区分.ヘッド) {
            gridItem.請求車輌ID = props.syaryoZyomuin.車輌ID
            gridItem.請求車番 = props.syaryoZyomuin.車番
          }
          if (gridItem.請求車輌区分コード === e請求車輌区分.トレーラー) {
            gridItem.請求車輌ID = props.syaryoZyomuin.トレーラ車輌ID
            gridItem.請求車番 = props.syaryoZyomuin.トレーラ車番
          }

          // 車輌データがある場合は登録
          if (車輌データ) {
            gridItem.稼働手当車種掛率区分コード =
              車輌データ.稼働手当車種掛率区分コード
            gridItem.稼働手当車種掛率区分ソート番号 =
              車輌データ.稼働手当車種掛率区分ソート番号?.toString()
            gridItem.稼働手当車種掛率区分名称1 =
              車輌データ.稼働手当車種掛率区分名称1
          }
        }
        // 請求計上日を請求内訳より登録

        switch (gridItem.計上基準日区分コード) {
          case e計上基準日区分.積日:
            gridItem.請求計上日 = gridItem.積日
            break
          case e計上基準日区分.卸日:
            gridItem.請求計上日 = gridItem.卸日
            break
        }

        // 乗務員変更にIDが入っていたらその情報をヘッドの乗務員として登録
        // それ以外の場合、乗務員が入力されていた場合そのまま登録、入力されていない場合は車輛乗務員の情報を入力
        if (変更後乗務員ID != null) {
          gridItem.乗務員ID = 変更後乗務員ID
          gridItem.乗務員コード = 変更後乗務員コード
          gridItem.乗務員名 = 変更後乗務員名
        } else {
          if (!props.isMihaisya && gridItem.乗務員ID == null) {
            gridItem.乗務員ID = props.syaryoZyomuin.乗務員ID
            gridItem.乗務員コード = props.syaryoZyomuin.乗務員コード
            gridItem.乗務員名 = props.syaryoZyomuin.乗務員名
          }
        }

        putData.push(gridItem)
      })

      if (putData) {
        const service = new zyutyuHaisyaService()
        let res: TApiResponse<TZyutyuHaisyaListGetRes[]> =
          await service.putList(putData)
        setAlertSource(res)
        if (res) {
          showInfoToast(`受注配車の更新が完了しました`)
          props.setIsShow(false)
          // 未配車の場合は
          if (props.isMihaisya) {
            mihaisyaSearch()
          } else {
            calenderSearch()
          }
        }
      } else {
        showInfoToast(`更新対象の配車がありません。`)
      }
    } catch (error) {
      setAlertSource(error)
    } finally {
      setIsConfirmModalShow(false)
      // 画面全体をリロード
    }
  }

  /**
   * 行削除
   */
  const gridDelete = async () => {
    if (!contextItem || flexGrid?.itemsSource === undefined) return
    // 新規行の場合
    if (contextItem.受注配車ID == null) {
      flexGrid?.itemsSource.remove(contextItem)

      setIsDeleteRowConfirmModalShow(false)
    } else {
      // 既存行の場合
      // 分割を行っている受注配車の場合、子供なら削除不可メッセージ、親なら子供も一緒に消える旨をメッセージ
      if (contextItem.卸地分割受注配車ID != null) {
        if (contextItem.請求対象フラグ === 1) {
          if (
            !window.confirm(`卸分割先の受注も削除されます。よろしいですか？`)
          ) {
            return
          }
        } else {
          setAlertSource({
            warns: [
              `卸分割された受注のため、削除できません。削除される場合、分割元の部所へご連絡ください。`,
            ],
          })
        }
      }
      try {
        const service = new zyutyuHaisyaService()
        const res = await service.deleteList([
          {
            受注配車ID: contextItem.受注配車ID,
            更新日時: contextItem.更新日時!,
          },
        ])
        setAlertSource(res)
        if (res) {
          showInfoToast(`受注No${contextItem.受注No}の削除が完了しました`)
          flexGrid?.itemsSource.remove(contextItem)
          setIsDeleteRowConfirmModalShow(false)
          calenderSearch()
        }
      } catch (error) {
        setAlertSource(error)
        setIsDeleteRowConfirmModalShow(false)
      }
    }
  }

  /**
   * 付替実施
   */
  const tukekae = async (req: THaisyaPostTukekaeReq) => {
    if (選択行 == null) return

    const dataItem: T配車入力Grid = 選択行?.dataItem
    try {
      const res = await new HaisyaService().postRegisterTukekae(
        dataItem.受注配車ID,
        req
      )
      if (res) {
        setAlertSource(res)
        // 画面内を更新
        // 戻ってきた受注配車枝番より卸地分割部所名を取得し行に埋め込む
        dataItem.卸地分割部所ID = res.data.運行部所ID
        dataItem.卸地分割部所名 = res.data.運行部所名
        dataItem.卸地分割受注配車ID = res.data.受注配車ID
        dataItem.請求対象フラグ = 1
        flexGrid?.refresh()
        showInfoToast(
          `枝番 ${res.data.受注伝票番号}-${res.data.受注枝番} を作成しました。`
        )
        setIsTukekaeModal(false)
        calenderSearch()
        mihaisyaSearch()
      }
    } catch (error) {
      setAlertSource(error)
    }
  }
  //#endregion

  //#region [effect]

  // gridリフレッシュ用
  useEffect(() => {
    if (isGridRefresh) {
      flexGrid?.refresh()
      setIsGridRefresh(false)
    }
  }, [isGridRefresh])

  // 初回データ取得
  useEffect(() => {
    Promise.all([
      new BusyoService().getList({}),
      new KubunService().getList(),
    ]).then(([部所ListRes, 区分マスタRes]) => {
      //区分値の確保

      set単位区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter(
            (d) => d.分類コード === 区分分類コード.マスタ.単位区分
          ),
          "区分コード",
          "名称1"
        )
      )

      set請求区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter(
            (d) => d.分類コード === 区分分類コード.受注配車_請求支払.請求区分
          ),
          "区分コード",
          "名称1"
        )
      )
      set課税区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter(
            (d) => d.分類コード === 区分分類コード.受注配車_請求支払.課税区分
          ),
          "区分コード",
          "名称1"
        )
      )

      set配車状態区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter(
            (d) =>
              d.分類コード === 区分分類コード.受注配車_請求支払.配車状態区分
          ),
          "区分コード",
          "名称1"
        )
      )

      set同乗場所区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter(
            (d) =>
              d.分類コード === 区分分類コード.受注配車_請求支払.同乗場所区分
          ),
          "区分コード",
          "名称1"
        )
      )

      set食事手当区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter(
            (d) => d.分類コード === 区分分類コード.マスタ.食事手当区分
          ),
          "数値1",
          "数値1"
        )
      )

      set稼働手当車種掛率区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter(
            (d) =>
              d.分類コード ===
              区分分類コード.受注配車_請求支払.稼働手当車種掛率区分
          ),
          "区分コード",
          "名称1"
        )
      )

      set部所List([...部所ListRes.data])
      set部所DataMap(
        new wjcGrid.DataMap(部所ListRes.data, "部所コード", "部所名")
      )
      set運行部所DataMap(
        new wjcGrid.DataMap(
          部所ListRes.data.filter((d) => d.運行部所フラグ === 1),
          "部所コード",
          "部所名"
        )
      )
    })
  }, [])

  // 初回表示時
  useEffect(() => {
    if (flexGrid != null && !isGridInitialized && props.isShow) {
      setIsGridInitialized(true)
    }
  }, [flexGrid, props.isShow])

  // 初回表紙分割、請求内訳取得用メソッド
  const 初回荷主請求取得 = async (rowData: TZyutyuHaisyaListGetRes[]) => {
    const 荷主IdList = rowData
      .filter((a) => a.荷主ID != null)
      .map((a) => a.荷主ID as number)
    const 荷主請求IdList = rowData
      .filter((a) => a.荷主請求ID != null)
      .map((a) => a.荷主請求ID as number)

    try {
      const res = await new NinusiSeikyuService().getList({
        荷主IdList,
        削除済み包含フラグ: true,
      })

      if (res && res.data) {
        set表紙分割List([...res.data])
      }
      const 内訳Res = await new NinusiSeikyuService().getListUchiwake({
        荷主請求IdList,
      })
      if (内訳Res && 内訳Res.data) {
        set請求内訳List([...内訳Res.data])
      }
    } catch (error) {
      setAlertSource(error)
    }
  }

  useEffect(() => {
    if (props.isShow) {
      if (!isGridInitialized) return
      if (flexGrid == null) return
      setIsSpinnerShow(true)

      setAlertSource(undefined)

      // 未配車の場合、一部を隠す
      未配車入力時非表示Bindings.forEach((bindings) => {
        const targetColumn = flexGrid.getColumn(bindings)
        if (targetColumn) targetColumn.visible = !props.isMihaisya
      })
      // const 卸地分割Col = flexGrid.getColumn("卸地分割")
      // const 卸地分割部所名Col = flexGrid.getColumn("卸地分割部所名")

      // if (卸地分割Col) 卸地分割Col.visible = !props.isMihaisya
      // if (卸地分割部所名Col) 卸地分割部所名Col.visible = !props.isMihaisya

      Promise.all([search(), getTukekae()])
        .then(async ([rowData, tukekaeList]) => {
          const 部所 = 部所List.find((a) => a.部所コード === 受注部所コード)
          部所Ref.current = 部所

          // 表示時処理
          // 一覧より取得した受注配車IDリストは表示順および配送順と一致しているため、そちらでソートする
          const sortedRowData = sortBy受注配車ID(
            props.zyutyuHaisyaList,
            rowData
          )
          const newData = createCollectionView(
            [...sortedRowData],
            [...tukekaeList]
          )
          // 配車済のデータの場合、車輌データを利用するため確保する
          if (!props.isMihaisya) {
            const 車輌Res = await new SyaryoService().get(
              props.syaryoZyomuin.車輌ID
            )
            if (車輌Res && 車輌Res.data) {
              set車輌データ(車輌Res.data)
            }
          }

          flexGrid.itemsSource = newData
          if (rowData.length < 8) {
            flexGrid!.allowAddNew = true
          } else {
            flexGrid!.allowAddNew = false
          }
          flexGrid!.refresh()
          if (rowData.length > 0) {
            初回荷主請求取得(rowData).then(() => {
              setIsGridInitialized(false)
            })
          } else {
            set表紙分割List([])
            set請求内訳List([])
            setIsGridInitialized(false)
          }
        })
        .catch((error) => {
          setAlertSource(error)
        })
        .finally(() => {
          setIsSpinnerShow(false)
        })
    } else {
      set変更後乗務員コード("")
      set変更後乗務員名("")
    }
  }, [props.isShow, isGridInitialized])

  // 荷主設定時の表紙分割設定用effect
  useEffect(() => {
    if (flexGrid == null) return

    util.set表紙分割DataMapFrom荷主コードChanged<
      TZyutyuHaisyaListGetRes,
      T表紙分割 & { displayMemberPath: string }
    >(
      flexGrid,
      表紙分割List.map((d) => ({
        ...d,
        displayMemberPath: `${d.表紙分割コード}: ${d.表紙名} (${d.荷主請求ID})`,
      })),
      "荷主請求ID",
      "荷主請求ID",
      "displayMemberPath",
      set表紙分割DataMap,
      (h) => h.displayMemberPath
    )

    // 請求内訳Listの更新
    const 請求内訳col = flexGrid.getColumn(
      nameofT<TZyutyuHaisyaListGetRes>("荷主請求内訳ID")
    )
    const 荷主請求IdList = 表紙分割List.map((a) => a.荷主請求ID)
    if (荷主請求IdList.length <= 0) {
      請求内訳col?.dataMap?.collectionView.sourceCollection.splice(
        0,
        請求内訳col?.dataMap.collectionView.sourceCollection.length
      )
      請求内訳col?.dataMap?.collectionView.refresh()
      set請求内訳List([])
      return
    }
    new NinusiSeikyuService()
      .getListUchiwake({
        荷主請求IdList,
        削除済み包含フラグ: true,
      })
      .then((請求内訳Res) => {
        請求内訳col?.dataMap?.collectionView.sourceCollection.splice(
          0,
          請求内訳col?.dataMap.collectionView.sourceCollection.length
        )
        請求内訳col?.dataMap?.collectionView.sourceCollection.push(
          ...請求内訳Res.data
        )
        請求内訳col?.dataMap?.collectionView.refresh()
        set請求内訳List([...請求内訳Res.data])
      })
  }, [表紙分割List])

  // 荷主コード変更によるdataMap変更用
  useEffect(() => {
    if (flexGrid == null) return
    if (!is荷主コード変更) return
    // 表紙分割Listの更新
    const 表紙分割col = flexGrid.getColumn(
      nameofT<TZyutyuHaisyaListGetRes>("荷主請求ID")
    )
    // 外部より取得するためにテーブルの荷主コードをすべて取得する
    const tableData: T配車入力Grid[] = flexGrid.collectionView.sourceCollection
    const 荷主IdList = tableData
      .map((a) => a.荷主ID as number)
      .filter((a) => a != null)

    if (荷主IdList.length <= 0) {
      if (表紙分割col == null || 表紙分割col.dataMap == null) return
      表紙分割col?.dataMap.collectionView.sourceCollection.splice(
        0,
        表紙分割col?.dataMap.collectionView.sourceCollection.length
      )
      表紙分割col?.dataMap.collectionView.refresh()
      set表紙分割List([])
      setIs荷主コード変更(false)
      return
    }

    new NinusiSeikyuService()
      .getList({
        荷主IdList,
        削除済み包含フラグ: true,
      })
      .then((荷主請求Res) => {
        if (表紙分割col == null || 表紙分割col.dataMap == null) return
        表紙分割col?.dataMap.collectionView.sourceCollection.splice(
          0,
          表紙分割col?.dataMap.collectionView.sourceCollection.length
        )
        表紙分割col?.dataMap.collectionView.sourceCollection.push(
          ...荷主請求Res.data
        )
        表紙分割col?.dataMap.collectionView.refresh()
        set表紙分割List([...荷主請求Res.data])
        setIs荷主コード変更(false)
      })
      .catch((error) => {
        setAlertSource(error)
      })
  }, [is荷主コード変更])

  // イベント付替え用のhookに格納する
  const cellEditEndedHandler = useGridEventHandler(
    flexGrid?.cellEditEnded,
    cellEditEnded
  )
  const pastedCellHandler = useGridEventHandler(
    flexGrid?.pastedCell,
    pastedCell
  )

  // 荷主請求更新による請求内訳リスト更新
  useEffect(() => {
    if (flexGrid == null) return
    util.setDataMapFrom荷主請求Changed<
      TZyutyuHaisyaListGetRes,
      T請求内訳 & { displayMemberPath: string }
    >(
      flexGrid,
      請求内訳List.map((d) => ({
        ...d,
        displayMemberPath: `${d.請求内訳コード}: ${d.請求内訳名} (${d.荷主請求内訳ID})`,
      })),
      "荷主請求内訳ID",
      "荷主請求内訳ID",
      "displayMemberPath",
      set請求内訳DataMap,
      (h) => h.displayMemberPath
    )
    // 荷主idと荷主請求id、荷主請求内訳idの組み合わせに不備がある場合データを消去
    checkId(表紙分割List, 請求内訳List, flexGrid)
    flexGrid?.refresh()
  }, [請求内訳List])

  //ファンクション内部のstate更新のためイベント付け替え
  useEffect(() => {
    if (isListGot) {
      cellEditEndedHandler.refresh()
      pastedCellHandler.refresh()
    }
  }, [表紙分割List, 請求内訳List, isListGot, isGridRefresh])

  // 車輌データが変わった際に新規行追加のメソッドを張替
  useEffect(() => {
    if (!flexGrid) return
    const collectionView = flexGrid.collectionView as wjcCore.CollectionView
    collectionView.newItemCreator = newItemCreator
    flexGrid.refresh()
    cellEditEndedHandler.refresh()
    pastedCellHandler.refresh()
  }, [車輌データ])

  const formatItemEndedHandler = useGridEventHandler(
    flexGrid?.formatItem,
    formatItem
  )
  const beginningEditCellHandler = useGridEventHandler(
    flexGrid?.beginningEdit,
    beginningEdit
  )
  useEffect(() => {
    formatItemEndedHandler.refresh()
    beginningEditCellHandler.refresh()
  }, [休日List])

  //#endregion

  //#region [jsxElement]
  return (
    <>
      <ModalOuter
        isShow={props.isShow}
        title={props.isMihaisya ? "未配車入力" : "配車入力"}
        setIsShow={props.setIsShow}
        dialogClassName="mw-95"
        footer={props.footer}>
        <Spinner inModal searching={isSpinnerShow}></Spinner>
        <Container fluid>
          {/* アラート表示 */}
          <Row>
            <Col>
              <LocalAlertComponent alertSource={AlertSource} />
            </Col>
          </Row>
          <form>
            <Row>
              <Col className="d-flex align-self-center">
                {!props.isMihaisya && (
                  <>
                    <div className="h-100 fs-5 me-2 fw-bold align-self-center">
                      <span>積車輌</span>
                    </div>
                    <table className="form-table align-self-center min-h-1rem">
                      <tbody>
                        <tr>
                          <th>積日</th>
                          <td className="read-only-table-cell">
                            <span className="me-3">
                              {props.tumibi &&
                                dayjs(props.tumibi).format("YYYY/MM/DD")}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table className="form-table align-self-center min-h-1rem ms-2">
                      <tbody>
                        <tr>
                          <th>車番</th>
                          <td className="read-only-table-cell">
                            <span className="me-3">
                              {props.syaryoZyomuin.車番}
                            </span>
                          </td>
                          <th>車種</th>
                          <td className="read-only-table-cell">
                            <span className="me-3">
                              {props.syaryoZyomuin.車種区分名称1}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    {props.syaryoZyomuin.トレーラ車番 && (
                      <table className="form-table align-self-center min-h-1rem ms-2">
                        <tbody>
                          <tr>
                            <th>トレーラ車番</th>
                            <td className="read-only-table-cell">
                              <span className="me-3">
                                {props.syaryoZyomuin.トレーラ車番}
                              </span>
                            </td>
                            <th>トレーラ車種</th>
                            <td className="read-only-table-cell">
                              <span className="me-3">
                                {props.syaryoZyomuin.トレーラ車種区分名称1}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                    <table className="form-table align-self-center ms-4">
                      <tbody>
                        <tr>
                          <th>一括乗務員変更</th>
                          <td>
                            <div className="input-group">
                              <TextInput
                                className={isInvalid車番 ? "is-error" : ""}
                                style={{ width: "6rem" }}
                                id="変更後乗務員コード"
                                name="変更後乗務員コード"
                                value={変更後乗務員コード}
                                onBlur={async (e) => {
                                  if (
                                    e.target.value != null &&
                                    e.target.value !== ""
                                  ) {
                                    try {
                                      const res =
                                        await new ZyomuinService().getList({
                                          社員コード: e.target.value,
                                          退職フラグ: 0,
                                          部所コード:
                                            部所Ref.current?.部所コード,
                                        })
                                      if (res == null || res.data.length <= 0) {
                                        setAlertSource({
                                          warns: [
                                            "入力された社員コードに紐づく社員は存在しません",
                                          ],
                                        })
                                        setIsInvalid車番(true)
                                      } else {
                                        set変更後乗務員ID(res.data[0].乗務員ID)
                                        set変更後乗務員名(res.data[0].社員氏名)
                                        setIsInvalid車番(false)
                                      }
                                    } catch (error) {
                                      setAlertSource(error)
                                    }
                                  } else {
                                    set変更後乗務員ID(undefined)
                                    set変更後乗務員名("")
                                    setIsInvalid車番(false)
                                  }
                                }}
                                setValue={(v) => {
                                  set変更後乗務員コード(v)
                                }}
                                maxLength={VALIDATE_CONSTANT.LENGTH.社員コード}
                                placeholder="CD"
                              />
                              <button type="button" className="icon-button">
                                <a
                                  href="*"
                                  onClick={(e) => {
                                    e.preventDefault()
                                    set乗務員検索対象("一括乗務員")
                                    setIs乗務員検索Modal(true)
                                  }}>
                                  <FontAwesomeIcon icon={faSearch} />
                                </a>
                              </button>
                              <TextInput
                                style={{ width: "15rem" }}
                                id="乗務員名"
                                name="変更後乗務員名"
                                value={変更後乗務員名}
                                isReadOnly
                                setValue={set変更後乗務員名}
                                maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                              />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </>
                )}
              </Col>
            </Row>
            <Row>
              <Col className="text-start my-2">
                <Button variant="primary" onClick={beforeSubmit}>
                  登録
                </Button>
              </Col>
            </Row>
          </form>
          <Row
            onDrop={(e) => {
              // react-dndが下のタグ内にいるためドロップイベントが伝播しないように抑制

              e.preventDefault()
              e.stopPropagation()
            }}>
            <Col>
              <wjrGrid.FlexGrid
                {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                isReadOnly={false}
                headersVisibility={wjcGrid.HeadersVisibility.Column}
                allowDragging={wjcGrid.AllowDragging.Columns}
                keyActionTab={wjcGrid.KeyAction.None}
                selectionMode={wjcGrid.SelectionMode.Cell}
                frozenColumns={7}
                allowSorting={false}
                initialized={gridInitialized}>
                {!props.isMihaisya && (
                  <wjrGrid.FlexGridColumn
                    binding="配送順"
                    width={100}
                    allowDragging={false}
                    wordWrap={true}
                    align="center"
                    isReadOnly={true}
                    cssClassAll={"read-only-cell"}
                    header="運行No">
                    <wjrGrid.FlexGridCellTemplate
                      cellType={wjrGrid.CellTemplateType.Cell}
                      template={(
                        context: TWijmoCellTemplateContext<T配車入力Grid>
                      ) => {
                        const max =
                          flexGrid?.collectionView.sourceCollection.length
                        return (
                          <div className="d-flex">
                            <div
                              style={{
                                visibility:
                                  context.row.index > 0 ? "visible" : "hidden",
                              }}>
                              <button
                                onClick={(e) => {
                                  set配送順(
                                    context.row.index,
                                    context.row.index - 1
                                  )
                                }}
                                className="btn-primary mx-2">
                                ↑
                              </button>
                            </div>{" "}
                            <div className="text-center">
                              {context.row.index + 1}
                            </div>{" "}
                            <div
                              style={{
                                visibility:
                                  context.row.index < max - 1
                                    ? "visible"
                                    : "hidden",
                              }}>
                              <button
                                onClick={(e) => {
                                  set配送順(
                                    context.row.index + 1,
                                    context.row.index
                                  )
                                }}
                                className="btn-primary mx-2">
                                ↓
                              </button>
                            </div>
                          </div>
                        )
                      }}></wjrGrid.FlexGridCellTemplate>
                  </wjrGrid.FlexGridColumn>
                )}
                <wjrGrid.FlexGridColumn
                  variant="waiting"
                  header="削除"
                  cssClassAll={"read-only-cell"}
                  allowDragging={false}
                  hasFilter={false}
                  allowSorting={false}
                  binding="受注配車id"
                  allowMerging={true}
                  selectable={false}
                  align="center"
                  width={60}
                  isReadOnly>
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<T配車入力Grid>
                    ) => {
                      const item: T配車入力Grid = context.item
                      let disabled = is請求確認済(item)
                      return (
                        <Button
                          type="button"
                          disabled={disabled}
                          variant="caution"
                          className="btn btn-small btn-primary move-edit-page"
                          onClick={(e) => {
                            e.preventDefault()
                            setContextItem(context.item)
                            setIsDeleteRowConfirmModalShow(true)
                          }}>
                          削除
                        </Button>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="受注No"
                  allowDragging={false}
                  isReadOnly={true}
                  cssClassAll={"read-only-cell"}
                  width={128}
                  header="受注No"></wjrGrid.FlexGridColumn>

                {/* パターン検索 */}
                <wjrGrid.FlexGridColumn
                  binding="受注配車パターンコード"
                  width={110}
                  header="パターンCD"
                  isRequired={false}
                  editor={
                    new wjcInput.AutoComplete(document.createElement("div"), {
                      itemsSourceFunction: getPatternItemsSource,
                      displayMemberPath: "displayName",
                      selectedValuePath: "受注配車パターンコード",
                    })
                  }>
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<T配車入力Grid>
                    ) => {
                      return (
                        <div className="d-flex justify-content-between">
                          <div className="text-start">
                            {context.item.受注配車パターンコード}
                          </div>
                          {!flexGrid?.isReadOnly &&
                            !context.row.isReadOnly &&
                            (context.item.受注配車ID == null ||
                              context.item.受注配車ID === 0) && (
                              <div className="text-end">
                                <a
                                  href="*"
                                  onClick={(e) => {
                                    e.preventDefault()
                                    setモーダル検索用荷主コード(
                                      context.item.荷主コード
                                    )
                                    setモーダル検索用荷主名(context.item.荷主名)
                                    set選択行(context.row)
                                    setIs受注配車パターン検索Modal(true)
                                  }}>
                                  <FontAwesomeIcon icon={faSearch} />
                                </a>
                              </div>
                            )}
                        </div>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>

                {/* 荷主 */}
                <wjrGrid.FlexGridColumn
                  binding="荷主コード"
                  width={90}
                  header="荷主CD"
                  editor={
                    new wjcInput.AutoComplete(document.createElement("div"), {
                      minLength: 2,
                      isEditable: true,
                      delay: 300,
                      itemsSourceFunction: (
                        query: string,
                        max: number,
                        callback: wjcInput.IGetItemsCallback
                      ) => {
                        return get荷主ItemsSourceByApi(query, max, callback)
                      },
                      displayMemberPath: "displayName",
                      selectedValuePath: "荷主コード",
                    })
                  }>
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<T配車入力Grid>
                    ) => {
                      return (
                        <div className="d-flex justify-content-between">
                          <div className="text-start">
                            {context.item.荷主コード}
                          </div>
                          {cellReadOnlyFlag(context) && (
                            <div className="text-end">
                              <a
                                href="*"
                                onClick={(e) => {
                                  e.preventDefault()
                                  set選択行(context.row)
                                  setIs荷主検索Modal(true)
                                }}>
                                <FontAwesomeIcon icon={faSearch} />
                              </a>
                            </div>
                          )}
                        </div>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>

                <wjrGrid.FlexGridColumn
                  binding="荷主名"
                  allowDragging={false}
                  cssClassAll={"read-only-cell"}
                  isReadOnly={true}
                  width={128}
                  header="荷主名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="荷主請求ID"
                  allowDragging={false}
                  width={128}
                  dataMap={表紙分割DataMap}
                  header="表紙名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="荷主依頼番号"
                  width={128}
                  header="荷主依頼No"></wjrGrid.FlexGridColumn>
                {/* 積卸時間 */}
                <wjrGrid.FlexGridColumn
                  binding="積日"
                  isReadOnly={!props.isMihaisya}
                  width={64}
                  editor={
                    new wjcInput.InputDate(document.createElement("div"), {
                      format: "MM/dd",
                    })
                  }
                  format={"d"}
                  header="積日">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<T配車入力Grid>
                    ) => {
                      let dt = ""
                      if (context.item.積日)
                        dt = dayjs(context.item.積日).format("MM/DD")
                      return <>{dt}</>
                    }}
                  />
                </wjrGrid.FlexGridColumn>

                <wjrGrid.FlexGridColumn
                  binding="積時間"
                  width={80}
                  header="積時間"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="卸日"
                  width={64}
                  editor={
                    new wjcInput.InputDate(document.createElement("div"), {
                      format: "MM/dd",
                    })
                  }
                  format={"d"}
                  header="卸日">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<T配車入力Grid>
                    ) => {
                      let dt = ""
                      if (context.item.卸日)
                        dt = dayjs(context.item.卸日).format("MM/DD")
                      return <>{dt}</>
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="卸時間"
                  width={80}
                  header="卸時間"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="積地数"
                  width={32}
                  cssClassAll={"read-only-cell"}
                  isReadOnly={true}
                  wordWrap={true}
                  align="right"
                  format="n0"
                  header="積地数"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="卸地数"
                  width={32}
                  cssClassAll={"read-only-cell"}
                  isReadOnly={true}
                  wordWrap={true}
                  align="right"
                  format="n0"
                  header="卸地数"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="品数"
                  width={32}
                  cssClassAll={"read-only-cell"}
                  isReadOnly={true}
                  wordWrap={true}
                  dataType={2}
                  format="n0"
                  header="品数"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="繰返運行数"
                  width={32}
                  wordWrap={true}
                  align="right"
                  format="n0"
                  header="繰返数"></wjrGrid.FlexGridColumn>
                {/* 積卸地 */}
                <wjrGrid.FlexGridColumn
                  width={80}
                  binding="積地積卸先コード"
                  header="積地CD"
                  isRequired={false}
                  editor={
                    new wjcInput.AutoComplete(document.createElement("div"), {
                      minLength: 1,
                      isEditable: true,
                      delay: 300,
                      itemsSourceFunction: (
                        query: string,
                        max: number,
                        callback: wjcInput.IGetItemsCallback
                      ) => {
                        const 荷主コード = editedRowData.current?.荷主コード
                        if (荷主コード == null || 荷主コード === "") {
                          callback([])
                          return
                        }
                        return get積卸ItemsSourceByApi(
                          query,
                          max,
                          callback,
                          荷主コード
                        )
                      },
                      displayMemberPath: "displayName",
                      selectedValuePath: "積卸先コード",
                    })
                  }>
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<T配車入力Grid>
                    ) => {
                      return (
                        <div className="d-flex justify-content-between">
                          <div className="text-start">
                            {context.item.積地積卸先コード}
                          </div>
                          {cellReadOnlyFlag(context) &&
                            (context.item.積地数 == null ||
                              !(context.item.積地数 > 1)) && (
                              <div className="text-end">
                                <a
                                  href="*"
                                  onClick={(e) => {
                                    e.preventDefault()
                                    setモーダル検索用荷主コード(
                                      context.item.荷主コード
                                    )
                                    setモーダル検索用荷主名(context.item.荷主名)
                                    set選択行(context.row)
                                    set積卸先検索対象("積")
                                    setIs積卸先検索Modal(true)
                                  }}>
                                  <FontAwesomeIcon icon={faSearch} />
                                </a>
                              </div>
                            )}
                        </div>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="積地社名"
                  width={128}
                  header="積地コード"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="積地都道府県"
                  width={80}
                  header="都道府県"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="積地市区町村"
                  width={80}
                  header="市区町村"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  width={80}
                  binding="卸地積卸先コード"
                  header="卸地CD"
                  isRequired={false}
                  editor={
                    new wjcInput.AutoComplete(document.createElement("div"), {
                      minLength: 1,
                      isEditable: true,
                      delay: 300,
                      itemsSourceFunction: (
                        query: string,
                        max: number,
                        callback: wjcInput.IGetItemsCallback
                      ) => {
                        const 荷主コード = editedRowData.current?.荷主コード
                        if (荷主コード == null || 荷主コード === "") {
                          callback([])
                          return
                        }
                        return get積卸ItemsSourceByApi(
                          query,
                          max,
                          callback,
                          荷主コード
                        )
                      },
                      displayMemberPath: "displayName",
                      selectedValuePath: "積卸先コード",
                    })
                  }>
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<T配車入力Grid>
                    ) => {
                      return (
                        <div className="d-flex justify-content-between">
                          <div className="text-start">
                            {context.item.卸地積卸先コード}
                          </div>
                          {cellReadOnlyFlag(context) &&
                            (context.item.卸地数 == null ||
                              !(context.item.卸地数 > 1)) && (
                              <div className="text-end">
                                <a
                                  href="*"
                                  onClick={(e) => {
                                    e.preventDefault()
                                    setモーダル検索用荷主コード(
                                      context.item.荷主コード
                                    )
                                    setモーダル検索用荷主名(context.item.荷主名)
                                    set選択行(context.row)
                                    set積卸先検索対象("卸")
                                    setIs積卸先検索Modal(true)
                                  }}>
                                  <FontAwesomeIcon icon={faSearch} />
                                </a>
                              </div>
                            )}
                        </div>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="卸地社名"
                  width={128}
                  header="卸地社名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="卸地都道府県"
                  width={80}
                  header="都道府県"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="卸地市区町村"
                  width={80}
                  header="市区町村"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="輸送備考"
                  width={144}
                  header="輸送備考"></wjrGrid.FlexGridColumn>

                {/* 品名 */}
                <wjrGrid.FlexGridColumn
                  width={80}
                  binding="品コード"
                  header="品CD"
                  editor={
                    new wjcInput.AutoComplete(document.createElement("div"), {
                      minLength: 1,
                      isEditable: true,
                      delay: 300,
                      itemsSourceFunction: (
                        query: string,
                        max: number,
                        callback: wjcInput.IGetItemsCallback
                      ) => {
                        const 荷主コード = editedRowData.current?.荷主コード
                        if (荷主コード == null || 荷主コード === "") {
                          callback([])
                          return
                        }
                        return get品名ItemsSourceByApi(
                          query,
                          max,
                          callback,
                          荷主コード
                        )
                      },
                      displayMemberPath: "displayName",
                      selectedValuePath: "荷主コード",
                    })
                  }
                  isRequired={false}>
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<T配車入力Grid>
                    ) => {
                      const is複数品数 =
                        context.item.品数 != null && context.item.品数 > 1
                      return (
                        <div className="d-flex justify-content-between">
                          <div className="text-start">
                            {context.item.品コード}
                          </div>
                          {!is複数品数 && cellReadOnlyFlag(context) && (
                            <div className="text-end">
                              <a
                                href="*"
                                onClick={(e) => {
                                  e.preventDefault()
                                  setモーダル検索用荷主コード(
                                    context.item.荷主コード
                                  )
                                  setモーダル検索用荷主名(context.item.荷主名)
                                  set選択行(context.row)
                                  setIs品名検索Modal(true)
                                }}>
                                <FontAwesomeIcon icon={faSearch} />
                              </a>
                            </div>
                          )}
                        </div>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="品名"
                  cssClassAll={"read-only-cell"}
                  width={128}
                  header="品名"></wjrGrid.FlexGridColumn>

                <wjrGrid.FlexGridColumn
                  binding="積載品数量"
                  width={64}
                  isRequired={false}
                  dataType={wjcCore.DataType.Number}
                  format={"N3"}
                  editor={
                    new wjcInput.InputNumber(document.createElement("div"), {
                      format: "N3",
                      isRequired: false,
                    })
                  }
                  header="数量"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="単位区分コード"
                  width={64}
                  isRequired={false}
                  header="単位"
                  dataMap={単位区分DataMap}></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="配車状態区分コード"
                  width={128}
                  isRequired={false}
                  header="配車状態"
                  dataMap={配車状態区分DataMap}></wjrGrid.FlexGridColumn>
                {/* 車輌 */}
                <wjrGrid.FlexGridColumn
                  binding="受注部所コード"
                  isReadOnly={true}
                  cssClassAll={"read-only-cell"}
                  dataMap={部所DataMap}
                  header="受注部所"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="運行部所コード"
                  dataMap={運行部所DataMap}
                  isReadOnly={!props.isMihaisya}
                  header="運行部所"></wjrGrid.FlexGridColumn>

                {/* 卸地車輌変更 */}
                <wjrGrid.FlexGridColumn binding="卸地分割" header="コマンド">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<T配車入力Grid>
                    ) => {
                      const item = context.item
                      // 荷主ID + 積日 + 卸日 + 積地社名 + 卸地社名 すべて入力済の場合のみ押下可
                      const disabled =
                        item.荷主ID == null ||
                        wjcCore.isNullOrWhiteSpace(item.積日 ?? "") ||
                        wjcCore.isNullOrWhiteSpace(item.卸日 ?? "") ||
                        wjcCore.isNullOrWhiteSpace(item.積地社名 ?? "") ||
                        wjcCore.isNullOrWhiteSpace(item.卸地社名 ?? "")

                      return item.卸地分割受注配車ID != null ||
                        item.受注配車ID == null ||
                        is請求確認済(item) ? (
                        <></>
                      ) : (
                        <Button
                          disabled={disabled}
                          onClick={() => {
                            set選択行(context.row)
                            setIsTukekaeModal(true)
                          }}
                          size="sm"
                          className="min-w-2rem">
                          分割
                        </Button>
                      )
                    }}></wjrGrid.FlexGridCellTemplate>
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="卸地分割部所名"
                  isReadOnly={true}
                  cssClassAll={"read-only-cell"}
                  header="卸地運行部所"></wjrGrid.FlexGridColumn>

                {/* トレーラ */}
                <wjrGrid.FlexGridColumn
                  binding="トレーラ車番"
                  cssClassAll={"read-only-cell"}
                  isReadOnly={true}
                  header="トレ車番"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="トレーラ車種区分名称1"
                  width={160}
                  cssClassAll={"read-only-cell"}
                  isReadOnly={true}
                  header="トレーラ車種"></wjrGrid.FlexGridColumn>

                {/* 乗務員 */}
                <wjrGrid.FlexGridColumn
                  binding="乗務員名"
                  header="運転者"
                  isRequired={false}
                  editor={
                    new wjcInput.AutoComplete(document.createElement("div"), {
                      minLength: 1,
                      isEditable: false,
                      delay: 300,
                      itemsSourceFunction: (
                        query: string,
                        max: number,
                        callback: wjcInput.IGetItemsCallback
                      ) => {
                        const 部所コード = editedRowData.current?.運行部所コード
                        if (部所コード == null || 部所コード === "") {
                          callback([])
                          return
                        }
                        return get乗務員ItemsSourceByApi(
                          query,
                          max,
                          callback,
                          部所コード
                        )
                      },
                      displayMemberPath: "displayName",
                      selectedValuePath: "社員氏名",
                    })
                  }>
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TZyutyuHaisyaListGetRes>
                    ) => {
                      return (
                        <div className="d-flex justify-content-between">
                          <div className="text-start">
                            {context.item.乗務員名}
                          </div>
                          {!flexGrid?.isReadOnly && !context.row.isReadOnly && (
                            <div className="text-end">
                              <a
                                href="*"
                                onClick={(e) => {
                                  e.preventDefault()
                                  set選択行(context.row)
                                  set乗務員検索対象("乗務員")
                                  setIs乗務員検索Modal(true)
                                }}>
                                <FontAwesomeIcon icon={faSearch} />
                              </a>
                            </div>
                          )}
                        </div>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>

                <wjrGrid.FlexGridColumn
                  binding="同乗者名"
                  header="同乗者"
                  isRequired={false}
                  editor={
                    new wjcInput.AutoComplete(document.createElement("div"), {
                      minLength: 1,
                      isEditable: false,
                      delay: 300,
                      itemsSourceFunction: (
                        query: string,
                        max: number,
                        callback: wjcInput.IGetItemsCallback
                      ) => {
                        const 部所コード = editedRowData.current?.運行部所コード
                        if (部所コード == null || 部所コード === "") {
                          callback([])
                          return
                        }
                        return get乗務員ItemsSourceByApi(
                          query,
                          max,
                          callback,
                          部所コード
                        )
                      },
                      displayMemberPath: "displayName",
                      selectedValuePath: "社員氏名",
                    })
                  }>
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<T配車入力Grid>
                    ) => {
                      return (
                        <div className="d-flex justify-content-between">
                          <div className="text-start">
                            {context.item.同乗者名}
                          </div>
                          <div className="text-end">
                            <a
                              href="*"
                              onClick={(e) => {
                                e.preventDefault()
                                set選択行(context.row)
                                set乗務員検索対象("同乗者")
                                setIs乗務員検索Modal(true)
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                            </a>
                          </div>
                        </div>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="同乗者場所区分コード"
                  isRequired={false}
                  dataMap={同乗場所区分DataMap}
                  header="同乗場所"></wjrGrid.FlexGridColumn>
                {/* 請求 */}
                <wjrGrid.FlexGridColumn
                  binding="荷主請求内訳ID"
                  dataMap={請求内訳DataMap}
                  isRequired={false}
                  header="請求内訳"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="請求区分コード"
                  dataMap={請求区分DataMap}
                  header="請求区分"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="単価"
                  cssClass="number-col"
                  isRequired={false}
                  dataType={wjcCore.DataType.Number}
                  header="数量単価"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="請求車番"
                  header="請求車番"
                  cssClassAll={"read-only-cell"}
                  isReadOnly={true}
                  isRequired={false}
                  width={100}></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="請求運送料課税区分コード"
                  width={64}
                  dataMap={課税区分DataMap}
                  header="非/課"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="請求運送料"
                  width={80}
                  cssClass="number-col"
                  header="運送料"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="請求付帯料課税区分コード"
                  width={64}
                  dataMap={課税区分DataMap}
                  header="非/課"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="請求付帯料"
                  width={80}
                  cssClass="number-col"
                  header="付帯料"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="請求高速料税込区分名称1"
                  width={64}
                  cssClassAll={"read-only-cell"}
                  isReadOnly={true}
                  header="込/抜"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="請求高速料"
                  width={80}
                  cssClass="number-col"
                  header="高速料"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="請求合計"
                  cssClass="number-col"
                  cssClassAll={"read-only-cell"}
                  isReadOnly={true}
                  header="請求合計"></wjrGrid.FlexGridColumn>
                {/* 運転手計上 */}
                <wjrGrid.FlexGridColumn
                  binding="食事手当"
                  width={80}
                  dataMap={食事手当区分DataMap}
                  isRequired={false}
                  header="食事代"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="乗務員売上額"
                  width={80}
                  header="乗務員売上"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="乗務員付帯料"
                  width={120}
                  cssClass="number-col"
                  isRequired={false}
                  dataType={wjcCore.DataType.Number}
                  header="乗務員付帯料"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="付帯高速料"
                  width={100}
                  cssClass="number-col"
                  isRequired={false}
                  dataType={wjcCore.DataType.Number}
                  header="付帯高速料"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="is乗務員売上手編集"
                  width={80}
                  align="center"
                  dataType={wjcCore.DataType.Boolean}
                  header="手入力"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="稼働手当車種掛率区分コード"
                  width={100}
                  isRequired={false}
                  isReadOnly={true}
                  cssClassAll={"read-only-cell"}
                  dataMap={稼働手当車種掛率区分DataMap}
                  header="稼働掛率"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="同乗者売上額"
                  width={80}
                  header="同乗者売上"></wjrGrid.FlexGridColumn>
              </wjrGrid.FlexGrid>
            </Col>
          </Row>
          {!props.isMihaisya && (
            <Row>
              <Col className="text-danger">
                <div>
                  修正中の情報は卸地車輛変更の際に反映されません。修正内容を登録後に該当の受注配車の卸地車輛変更を行ってください。
                </div>
                <div>
                  トレーラは新規登録時以外更新されません。受注配車一覧画面・受注配車入力画面より変更を行ってください。
                </div>
              </Col>
            </Row>
          )}
        </Container>
      </ModalOuter>

      {/* モーダル */}
      {/* 荷主検索 */}
      <NinusiSeikyuSearchModal
        isShow={is荷主検索Modal}
        setIsShow={setIs荷主検索Modal}
        setNinusi={(荷主請求) => {
          if (選択行 == null || 選択行.dataItem == null) return
          const casted: T配車入力Grid = 選択行.dataItem
          casted.荷主コード = 荷主請求.荷主コード
          casted.荷主名 = 荷主請求.荷主略称1
          casted.荷主ID = 荷主請求.荷主ID
          casted.表紙分割コード = 荷主請求.表紙分割コード
          casted.荷主請求ID = 荷主請求.荷主請求ID
          casted.表紙名 = 荷主請求.表紙名
          casted.請求高速料税込区分コード = 荷主請求.高速料税込区分コード
          casted.請求高速料税込区分名称1 = 荷主請求.高速料税込区分名称1
          casted.支払高速料税込区分コード = 荷主請求.高速料税込区分コード
          casted.品代端数計算区分コード = 荷主請求.品代端数計算区分コード
          casted.品代端数計算区分ソート番号 =
            荷主請求.品代端数計算区分ソート番号
          casted.品代端数計算区分名称1 = 荷主請求.品代端数計算区分名称1
          setIs荷主コード変更(true)
          flexGrid?.refresh()
        }}></NinusiSeikyuSearchModal>
      {/* 受注配車パターン検索 */}
      <ZyutyuHaisyaPatternModal
        isShow={is受注配車パターン検索Modal}
        setIsShow={setIs受注配車パターン検索Modal}
        ninusiCode={モーダル検索用荷主コード}
        ninusiName={モーダル検索用荷主名}
        zyutyubusyo={部所Ref.current}
        setPattern={(受注配車パターン) => {
          if (選択行 == null || 選択行.dataItem == null) return
          const casted: T配車入力Grid = 選択行.dataItem
          setPattern(受注配車パターン, casted, false)
          set請求車番(casted)
          setIs荷主コード変更(true)
          flexGrid?.refresh()
        }}></ZyutyuHaisyaPatternModal>

      {/* 積卸先検索 */}
      <TumiOrosiSakiSearchModal
        size="lg"
        setIsShow={setIs積卸先検索Modal}
        isShow={is積卸先検索Modal}
        ninusiCode={モーダル検索用荷主コード}
        setTumiOrosiSaki={(積卸先) => {
          if (選択行 && 選択行.dataItem) {
            const casted: T配車入力Grid = 選択行.dataItem
            switch (積卸先検索対象) {
              case "積":
                casted.積地積卸先ID = 積卸先.積卸先ID
                casted.積地積卸先コード = 積卸先.積卸先コード
                casted.積地社名 = 積卸先.積卸先名
                casted.積地都道府県 = 積卸先.都道府県名漢字 ?? ""
                casted.積地市区町村 = 積卸先.住所２ ?? ""
                break
              case "卸":
                casted.卸地積卸先ID = 積卸先.積卸先ID
                casted.卸地積卸先コード = 積卸先.積卸先コード
                casted.卸地社名 = 積卸先.積卸先名
                casted.卸地都道府県 = 積卸先.都道府県名漢字 ?? ""
                casted.卸地市区町村 = 積卸先.住所２ ?? ""

                break
              default:
                break
            }
            flexGrid?.refresh()
          }
        }}></TumiOrosiSakiSearchModal>

      {/* 車輌検索 */}
      {/* <SyaryoSearchModal
        setIsShow={(v) => {
          setIs車輌検索Modal(v)
        }}
        isShow={is車輌検索Modal}
        busyoCode={車輌検索用部所コード}
        setSyaryo={(車輌) => {
          if (選択行 && 選択行.dataItem) {
            const casted: T配車入力Grid = 選択行.dataItem
            casted.請求車輌ID = 車輌.車輌ID
            casted.請求車番 = 車輌.車番

            flexGrid?.refresh()
          }
        }}></SyaryoSearchModal> */}

      {/* 品名検索 */}
      <HinmeiSearchModal
        size="lg"
        setIsShow={setIs品名検索Modal}
        isShow={is品名検索Modal}
        ninusiCode={モーダル検索用荷主コード}
        ninusiName={モーダル検索用荷主名}
        setHinmei={(品名) => {
          if (選択行 && 選択行.dataItem) {
            const casted: T配車入力Grid = 選択行.dataItem
            casted.荷主品名ID = 品名.荷主品名ID
            casted.品コード = 品名.品コード
            casted.品名 = 品名.品名
            casted.単位区分コード = 品名.単位区分コード
            flexGrid?.refresh()
          }
        }}></HinmeiSearchModal>
      {/* 乗務員検索 */}
      <ZyomuinSearchModal
        isShow={is乗務員検索Modal}
        setIsShow={setIs乗務員検索Modal}
        busyoCode={部所Ref.current?.部所コード}
        setZyomuin={(乗務員) => {
          switch (乗務員検索対象) {
            case "一括乗務員":
              // 乗務員は一律のため画面外の項目
              set変更後乗務員コード(乗務員.社員コード)
              set変更後乗務員名(乗務員.社員氏名)
              set変更後乗務員ID(乗務員.乗務員ID)
              break
            case "乗務員":
              if (選択行 && 選択行.dataItem) {
                const casted: T配車入力Grid = 選択行.dataItem

                casted.乗務員ID = 乗務員.乗務員ID
                casted.乗務員コード = 乗務員.社員コード
                casted.乗務員名 = 乗務員.社員氏名
              }
              flexGrid?.refresh()
              break
            case "同乗者":
              if (選択行 && 選択行.dataItem) {
                const casted: T配車入力Grid = 選択行.dataItem
                casted.同乗者乗務員ID = 乗務員.乗務員ID
                casted.同乗者コード = 乗務員.社員コード
                casted.同乗者名 = 乗務員.社員氏名
                casted.同乗者売上額 = 同乗者売上計算(casted.乗務員売上額)
              }
              flexGrid?.refresh()
              break
            default:
              break
          }
        }}></ZyomuinSearchModal>

      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={gridRegister}>
        入力された内容で更新しますか？
      </ConfirmModal>
      <ConfirmModal
        isShow={isDeleteRowConfirmModalShow}
        hideHandler={setIsDeleteRowConfirmModalShow}
        submitHandler={gridDelete}>
        選択行を削除しますか？
      </ConfirmModal>

      {/* 付替用モーダル */}
      <OrosiChangeModal
        isShow={isTukekaeModal}
        setIsShow={setIsTukekaeModal}
        部所ItemsSource={部所List}
        parentData={選択行?.dataItem}
        setTukekae={async (req) => {
          return tukekae(req)
        }}></OrosiChangeModal>
    </>
  )
  //#endregion
}

export default HaisyaRegisterModal
